// extracted by mini-css-extract-plugin
export var navigation = "navigation-module--navigation--tCgAu";
export var logo = "navigation-module--logo--3Yqkb";
export var space = "navigation-module--space--2vBUM";
export var navigationItem = "navigation-module--navigationItem--3NUGy";
export var lang = "navigation-module--lang--26c2P";
export var navActive = "navigation-module--nav-active--3M75q";